import { render, staticRenderFns } from "./scMenu.vue?vue&type=template&id=42cbc0a6&scoped=true&"
import script from "./scMenu.vue?vue&type=script&lang=js&"
export * from "./scMenu.vue?vue&type=script&lang=js&"
import style0 from "./scMenu.vue?vue&type=style&index=0&id=42cbc0a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cbc0a6",
  null
  
)

export default component.exports